import React, { type ReactNode } from 'react';

import { Card, DeathGame, EstValue, Incoming, Label, Meme, Ornament, PriceGame, Resurrection } from './components';

import { StyledFloorActivity } from './styles';

export interface FloorActivityProps {
    children: ReactNode;
    isLoading?: boolean;
}

export function FloorActivity({ children, isLoading }: FloorActivityProps) {
    return <StyledFloorActivity $isLoading={isLoading}>{children}</StyledFloorActivity>;
}

FloorActivity.Card = Card;
FloorActivity.DeathGame = DeathGame;
FloorActivity.EstValue = EstValue;
FloorActivity.Incoming = Incoming;
FloorActivity.Label = Label;
FloorActivity.Meme = Meme;
FloorActivity.Ornament = Ornament;
FloorActivity.PriceGame = PriceGame;
FloorActivity.Resurrection = Resurrection;
